import { FormControl, FormControlLabel, Radio, RadioGroup, Stack } from '@mui/material'
import { connectField } from 'dynamic-uniforms'
import { useCiboAutoForm } from './CiboAutoFormContext'
import { ClearButton } from './ClearButton'
import { FieldLabel } from './FieldLabel'
import { ValidationMessages } from './ValidationMessages'

type RadioOptionsInputProps = {
  name: string
  value: string
  label?: string
  onChange: (value: string | undefined) => void
  disabled?: boolean
  error?: { message: string }
  required: boolean
  oneOf: any[]
  [key: string]: any
}

export function RadioOptionsInput(props: RadioOptionsInputProps) {
  const { name, value, label, onChange, disabled, required } = props
  const { touch } = useCiboAutoForm()
  const canClear = !disabled && value !== undefined && value !== ''

  const options = (props.oneOf || props.options || []).map((option: any) =>
    typeof option === 'object'
      ? { value: option.const ?? option.value, label: option.label ?? option.const ?? option.value }
      : { value: option, label: option }
  )

  return (
    <FormControl fullWidth required={required} disabled={disabled}>
      {label && <FieldLabel label={label} required={required} />}

      <Stack direction="row" alignItems="center">
        <RadioGroup
          row
          name={name}
          value={value || ''}
          onChange={e => {
            const value = e.target.value
            onChange(`${value}`)
            touch(name)
          }}
          onBlur={() => touch(name)}
        >
          {options.map((option: any) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio />}
              label={option.label}
              disabled={disabled}
            />
          ))}
        </RadioGroup>

        {canClear && (
          <ClearButton
            tooltipKey="clearButton.selection"
            onClick={() => {
              onChange(undefined)
              touch(name)
            }}
            sx={{ marginLeft: 1 }}
          />
        )}
      </Stack>

      <ValidationMessages
        fieldName={props.name}
        error={props.error as { message: string } | undefined}
      />
    </FormControl>
  )
}

export default connectField(RadioOptionsInput)
